import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "store";

interface PreferredLanguageState {
    hasLoans: boolean;
    isLanguageToggleLocked: boolean;
}

const initialState: PreferredLanguageState = {
    hasLoans: false,
    isLanguageToggleLocked: false,
};

const preferredLanguageSlice = createSlice({
    name: "preferredLanguage",
    initialState,
    reducers: {
        setHasLoans(state, action: PayloadAction<boolean>) {
            state.hasLoans = action.payload;
        },
        setIsLanguageToggleLocked(state, action: PayloadAction<boolean>) {
            state.isLanguageToggleLocked = action.payload;
        },
    },
});

export const isPostLosLoan = (loanNumber?: string | null): boolean => Boolean(loanNumber && loanNumber !== "TBD");

export const { setHasLoans, setIsLanguageToggleLocked } = preferredLanguageSlice.actions;

export const selectIsLanguageToggleLocked = (state: RootState) => state.preferredLanguage.isLanguageToggleLocked;

export const selectHasLoans = (state: RootState) => state.preferredLanguage.hasLoans;

export default preferredLanguageSlice.reducer;
